import React, {useState, useEffect} from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading,TextArea} from 'components/form';
import {required, validationWrapper, number} from 'lib/formValidations';
import {transformTranslateFromValues, transformTranslateServerValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {useCore} from 'store/core'
// components

export default function Edit(props) {

    const core = useCore();
    const {show, item} = props

    return (
        <>
            <Modal show={props.show} handleClose={props.close} title={props.title}>
                <Formik
                    initialValues={{...transformTranslateServerValues(item)}}
                    onSubmit={async (values, {setSubmitting}) => {
                        await props.submit(transformTranslateFromValues(values), item.id);
                        props.close();
                        setSubmitting(false);
                    }}
                    enableReinitialize
                >

                    {({isSubmitting, dirty}) => (
                        <Form>
                            <div className="modal-body gap-y-3">
                                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                                    <Field
                                        placeholder="نام"
                                        name="name"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        placeholder="name"
                                        name="_en*name*text"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        label="توضیحات"
                                        name="desc"
                                        component={TextArea}
                                    />
                                    <Field
                                        label="description"
                                        name="_en*desc*text"
                                        component={TextArea}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer text-right">
                                <button className="btn btn-primary w-20" type="submit"
                                        disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                                    <Loading/> : 'ذخیره'}</button>
                                <button type="button"
                                        disabled={isSubmitting}
                                        onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
